import { CheckCircle2, Flame } from "lucide-react";
import logoFEOHorizontal from "@/assets/logo-feo-horizontal.png.asset.json";
import { useOfferCheckoutUrl } from "@/lib/checkout/use-offer-checkout-url";

const IMERSOES: Array<{ nome: string; texto: string; img: string }> = [
  {
    nome: "Imersão em Coluna Lombar",
    texto:
      "O que há de mais atual no cuidado de queixas lombares agudas e crônicas, passando pela epidemiologia, avaliação clínica, principais intervenções e discussão de casos que conectam as evidências científicas à prática.\n\n",
    img: "https://d335luupugsy2.cloudfront.net/cms/files/387213/1765200228/$6e1t8vt153c",
  },
  {
    nome: "Imersão em Lesões dos MMII",
    texto:
      "O estado da arte das principais lesões não traumáticas dos MMII, com conteúdos dedicados ao quadril, joelho, tornozelo e pé, conectando atualização científica e tomada de decisão clínica.\n\n",
    img: "https://d335luupugsy2.cloudfront.net/cms/files/387213/1765200228/$s2s81dhgdwp",
  },
  {
    nome: "IMERSÃO EM DOR",
    texto:
      "As abordagens mais atuais para o cuidado de pacientes com dor, incluindo Educação em Dor, Terapias de Exposição, estratégias relacionadas ao comportamento e aplicação prática da CFT por meio da discussão de casos clínicos.\n\n",
    img: "https://d335luupugsy2.cloudfront.net/cms/files/387213/1765200228/$ssb7i6t6bgm",
  },
  {
    nome: "Imersão em Prescrição de Exercícios",
    texto:
      "O que existe de mais novo na prescrição de exercícios para pacientes com queixas de dor. São quatro pilares: Bases Biomecânicas e Exercícios, Conceitos de Controle Motor, Dor e Motivação e Adesão.\n\n",
    img: "https://d335luupugsy2.cloudfront.net/cms/files/387213/1765200228/$cgdspe1pj05",
  },
  {
    nome: "Imersão em Agentes Eletrofísicos na Prática",
    texto:
      "Os principais agentes eletrofísicos utilizados na reabilitação musculoesquelética. Aprenda mecanismos, indicações, dosimetria, segurança e evidências científicas para escolher e aplicar cada recurso com critério.\n\n",
    img: "https://d335luupugsy2.cloudfront.net/cms/files/387213/1765200228/$g220jxh7mh9",
  },
  {
    nome: "Imersão em Reabilitação de Fraturas",
    texto:
      "Os principais conceitos para a reabilitação de fraturas dos MMSS e MMII, com aulas sobre úmero proximal, fêmur proximal e abordagem de pacientes politraumatizados, da avaliação inicial à progressão do tratamento.\n\n",
    img: "https://d335luupugsy2.cloudfront.net/cms/files/387213/1765200228/$dfj9x7xptp5",
  },
  {
    nome: "Imersão em Terapia Manual Ortopédica",
    texto:
      "O cenário atual e suas principais aplicações clínicas, passando por mobilização, manipulação, mobilização com movimento e mobilização neural, conectando as técnicas ao raciocínio clínico e às evidências científicas.\n\n",
    img: "https://d335luupugsy2.cloudfront.net/cms/files/387213/1765200228/$zr4l3hklnum",
  },
];

export const COMBO_FAQ = [
  {
    q: "Ainda não sou formado(a) em fisioterapia, posso fazer as Imersões?",
    a: "Pode sim! As Imersões do Portal Fisio em Ortopedia são direcionadas para estudantes de fisioterapia e fisioterapeutas.",
  },
  { q: "Tem certificado?", a: "Sim. Todas as Imersões oferecem certificados de 8 horas." },
  { q: "Quanto tempo terei de acesso?", a: "Você terá 10 anos de acesso." },
  { q: "Quais são as formas de pagamento?", a: "Cartão de Crédito ou Pix." },
];

export function ComboImersoesContent({ defaultCheckoutUrl }: { defaultCheckoutUrl: string }) {
  const CHECKOUT_URL = useOfferCheckoutUrl(defaultCheckoutUrl);
  return (
    <main className="min-h-screen bg-[#050a1f] text-white antialiased">
      {/* CONFIRMAÇÃO */}
      <div className="bg-[#00b899] text-white">
        <div className="mx-auto max-w-5xl px-4 py-3 text-center text-xs sm:text-sm font-semibold flex items-center justify-center gap-2">
          <CheckCircle2 className="w-5 h-5" />
          O seu curso gratuito já está disponível no e-mail!
        </div>
      </div>

      {/* HERO OFERTA */}
      <section className="relative overflow-hidden bg-gradient-to-b from-[#0a1240] via-[#0d1a56] to-[#081137]">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -top-40 left-1/2 -translate-x-1/2 h-[600px] w-[900px] rounded-full bg-[#00b899]/25 blur-[160px]" />
          <div className="absolute bottom-0 -right-40 h-[420px] w-[420px] rounded-full bg-[#6c63ff]/20 blur-[140px]" />
        </div>

        <div className="relative mx-auto max-w-4xl px-4 sm:px-6 pt-16 sm:pt-24 pb-16 sm:pb-24 text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 backdrop-blur px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-[#6ee7c7]">
            <Flame className="w-4 h-4 shrink-0" />
            Oferta Exclusiva desta Página
          </span>
          <h1 className="mt-6 text-3xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05]">
            7 Imersões da FEO.<br />
            <span className="bg-gradient-to-r from-[#6ee7c7] via-[#00c9d6] to-[#00b899] bg-clip-text text-transparent">
              O preço? R$9,90.
            </span>
            <br />
            Estar desatualizado custa muito mais.
          </h1>

          <p className="mt-6 text-lg sm:text-xl text-white/80 max-w-2xl mx-auto">
            Acesse aulas com referências da fisioterapia ortopédica e leve mais critério para as decisões que você toma todos os dias na clínica.
          </p>

          <div className="mt-10 inline-flex flex-col items-center gap-4">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.05] backdrop-blur px-5 py-2">
              <span className="text-sm text-white/60">
                De <span className="line-through">R$329</span> por
              </span>
              <span className="text-3xl font-black text-white">R$9,90</span>
            </div>

            <a
              href={CHECKOUT_URL}
              target="_blank"
              rel="noopener"
              className="group inline-flex items-center justify-center gap-3 rounded-xl bg-[#00b899] hover:bg-[#00a085] text-white font-black text-base sm:text-lg px-10 py-4 shadow-xl shadow-[#00b899]/30 hover:-translate-y-0.5 transition"
            >
              Quero as 7 imersões
              <span className="transition-transform group-hover:translate-x-1">→</span>
            </a>
            <p className="text-sm text-white/60">
              Pagamento único. Liberação Imediata.
              <br />
              Acesso por 10 anos.
            </p>
          </div>
        </div>
      </section>

      {/* IMERSÕES */}
      <section className="relative bg-[#f8fafc] text-slate-900 px-4 sm:px-6 py-20 sm:py-28">
        <div className="mx-auto max-w-6xl">
          <div className="text-center">
            <span className="text-xs font-bold uppercase tracking-[0.28em] text-[#00b899]">
              O que você recebe
            </span>
            <h2 className="mt-4 text-3xl sm:text-5xl font-black tracking-tight text-[#0d1a56]">
              Confira as 7 imersões que você terá acesso!
            </h2>
          </div>

          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {IMERSOES.map((im) => (
              <article
                key={im.nome}
                className="flex flex-col rounded-2xl bg-white border border-slate-200/80 overflow-hidden shadow-[0_1px_2px_rgba(13,26,86,0.04)] hover:shadow-lg hover:border-slate-300 transition"
              >
                <div className="aspect-[16/10] w-full overflow-hidden bg-slate-100">
                  <img src={im.img} alt={im.nome} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="p-6">
                  <h3 className="text-sm font-bold uppercase tracking-[0.14em] text-[#4f5bd5]">
                    {im.nome}
                  </h3>
                  <p className="mt-3 text-slate-600 text-sm leading-relaxed whitespace-pre-wrap">{im.texto}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-16 text-center">
            <p className="mx-auto max-w-2xl text-lg sm:text-xl text-slate-600">
              Cada imersão já foi vendida separadamente por R$47.
            </p>
            <a
              href={CHECKOUT_URL}
              target="_blank"
              rel="noopener"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#0d1a56] hover:bg-[#00b899] text-white font-black px-9 py-4 transition"
            >
              LIBERAR AS 7 IMERSÕES POR R$9,90 →
            </a>
            <p className="mt-4 text-sm text-slate-500">
              De <span className="line-through">R$ 329</span> por apenas <strong className="text-slate-700">R$ 9,90</strong>
            </p>
          </div>
        </div>
      </section>

      {/* MASTERCLASSES */}
      <section className="relative bg-[#f4f7fb] text-slate-900 px-4 sm:px-6 py-20 sm:py-28">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-[1.7rem] sm:text-4xl lg:text-[2.35rem] font-black tracking-tight leading-tight text-[#0d1a56]">
            Sete temas que atravessam sua rotina.<br />
            Uma condição exclusiva para acessar todos eles.
          </h2>
          <div className="mt-8 space-y-5 text-base sm:text-lg text-slate-700 leading-relaxed">
            <p>
              As Imersões da FEO conectam evidência, raciocínio e aplicação prática em encontros conduzidos por profissionais que são referência em suas áreas.
            </p>
            <p>
              São sete masterclasses, sobre temas que atravessam a rotina musculoesquelética, reunidas para ampliar o repertório por trás das decisões que você toma diante de cada caso.
            </p>
            <p>
              E, somente nesta página, você pode liberar o acesso completo às sete Imersões por R$9,90, uma condição exclusiva para quem acaba de entrar no ecossistema FEO.
            </p>
            <p className="text-[#0d1a56] font-black text-xl sm:text-2xl">
              Mais clareza. Mais critério. Mais segurança para decidir.
            </p>
          </div>

          <div className="mt-10">
            <a
              href={CHECKOUT_URL}
              target="_blank"
              rel="noopener"
              className="inline-flex items-center gap-2 rounded-full bg-[#00b899] hover:bg-[#00a085] text-white font-black px-9 py-4 transition"
            >
              QUERO APROVEITAR →
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-white text-slate-900 px-4 sm:px-6 py-20 sm:py-24">
        <div className="mx-auto max-w-3xl">
          <div className="text-center mb-10">
            <span className="text-xs font-bold uppercase tracking-[0.28em] text-[#00b899]">
              Perguntas Frequentes
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-black tracking-tight text-[#0d1a56]">
              Ficou com alguma dúvida?
            </h2>
          </div>
          <div className="space-y-3">
            {COMBO_FAQ.map((f) => (
              <details key={f.q} className="group rounded-2xl border border-slate-200 bg-white p-5 open:shadow-md transition">
                <summary className="cursor-pointer list-none font-bold text-slate-900 flex items-center justify-between gap-3">
                  {f.q}
                  <span className="grid place-items-center w-7 h-7 rounded-full bg-slate-100 text-[#00b899] group-open:bg-[#00b899] group-open:text-white group-open:rotate-45 transition">+</span>
                </summary>
                <p className="mt-3 text-slate-600 leading-relaxed">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* DOBRA FINAL */}
      <section className="bg-[#050a1f] text-white text-center px-4 py-16 sm:py-20">
        <img src={logoFEOHorizontal.url} alt="Fisio em Ortopedia" className="mx-auto h-14 sm:h-16 w-auto" loading="lazy" />
        <a
          href={CHECKOUT_URL}
          target="_blank"
          rel="noopener"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#00b899] hover:bg-[#00a085] text-white font-black px-9 py-4 transition"
        >
          ACESSE POR R$9,90 →
        </a>
      </section>

      <footer className="bg-[#02061a] text-white/50 text-center text-sm py-6 px-4">
        © {new Date().getFullYear()} Portal Fisio em Ortopedia · Todos os direitos reservados
      </footer>
    </main>
  );
}
